import { useState, useEffect } from "react";
import {
    DataGridPremium
} from "@mui/x-data-grid-premium";
import classes from "../../Challenge.module.css";
import AUTH_CONTEXT from "../../../../store";
import Loader from "../../../../components/Loader/Loader";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { BASE_PATH_TO_HOME } from "../../../../base_routes_paths/data_paths";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import CustomToolbar from "../../../../components/toolbar";
import { BASE_PATH_TO_ADD_SOLO_CHALLENGE_MILESTONES, BASE_PATH_TO_UPDATE_SOLO_CHALLENGE_MILESTONES } from "../../../../base_routes_paths/challenge_paths";
import { SoloChallengeMilestoneServices } from "../../../../services/challenge_services";

const SoloChallengeRewardsList = (props) => {
    const { token, fileName } = AUTH_CONTEXT();
    const EXPORT_FILENAME = `${fileName}_SoloChallengeMilestonesList`;
    const navigate = useNavigate()
    const userColumns = [
        {
            field: "Level",
            headerName: "Level",
            width: 80,
        },
        {
            field: "Rewards",
            headerName: "Rewards",
            width: 400,
            height: 500,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                const Rewards = params.row.Rewards

                return (
                    <div>
                        <table style={{ textAlign: "center" }}>
                            <thead>
                                <tr>
                                    <th style={{ paddingRight: 25 }}>Milestone Number</th>
                                    <th style={{ paddingRight: 25 }}>Amount Percentage</th>
                                    <th>IsActive</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Rewards.map((reward, index) => (
                                    <tr key={index}>
                                        <td style={{ paddingRight: 25 }}>{reward.CutOffNumber}</td>
                                        <td style={{ paddingRight: 25 }}>{reward.Amount}</td>
                                        <td>{reward.IsActive === true ? "true" : "false"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div >
                );
            },
        },
    ];

    const [isLoading, setIsLoading] = useState(false);
    const [isDataFetched, setIsDataFetched] = useState(false);
    let ChallengeData = [];
    const [data, setData] = useState(ChallengeData);

    const FetchResponseGetAllUserDetails = async () => {
        try {
            let response = await SoloChallengeMilestoneServices.getAllSoloChallengeMilestone(token, navigate);
            setIsLoading(true);
            setIsDataFetched(true);
            toast.success("Data fetched successfully!!", {
                position: "bottom-left",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return response.data;
        } catch (e) {
            setIsLoading(false);
            setIsDataFetched(false);
            toast.error(e.message, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };

    useEffect(() => {
        if (!isDataFetched) {
            FetchResponseGetAllUserDetails()
                .then((result) => {
                    let input = result.map(({ _id: id, ...result }) => ({
                        id,
                        ...result,
                    }));
                    setData(input);
                })
                .catch((err) => console.log(err));
        }
    }, []);

    const handleDelete = (id) => {
        SoloChallengeMilestoneServices.deleteSoloChallengeMilestone(id, token);
    };

    const actionColumn = [
        {
            field: "action",
            headerName: "Action",
            width: 200,
            renderCell: (params) => {
                return (
                    <div className={classes.cellAction}>
                        <Link
                            href={`${BASE_PATH_TO_UPDATE_SOLO_CHALLENGE_MILESTONES}/` + params.row.id}
                            style={{ textDecoration: "none" }}
                        >
                            <div className={classes.viewButton}>Update</div>
                        </Link>
                        <div
                            className={classes.deleteButton}
                            onClick={() => handleDelete(params.row.id)}
                        >
                            Delete
                        </div>
                    </div>
                );
            },
        },
    ];

    return (
        <div className={classes.datatable}>
            <Breadcrumbs aria-label="breadcrumb" sx={{ marginBottom: 1 }}>
                <Link underline="hover" color="inherit" href={BASE_PATH_TO_HOME}>
                    Dashboard
                </Link>
                <Typography color="text.primary">
                    Challenges
                </Typography>
                <Typography color="text.primary">Solo Challenges Milestones List</Typography>
            </Breadcrumbs>
            {isLoading && (
                <DataGridPremium
                    rows={data}
                    columns={userColumns.concat(actionColumn)}
                    slots={{
                        toolbar: () => (
                            <CustomToolbar
                                EXPORT_FILENAME={EXPORT_FILENAME}
                                onClickCreate={() => {
                                    navigate(BASE_PATH_TO_ADD_SOLO_CHALLENGE_MILESTONES);
                                }}
                                displayCreate={""}
                                onClickUpdate={() => { }}
                                displayUpdate={"none"}
                            />
                        ),
                    }}
                    rowHeight={150}
                    pagination
                    initialState={{
                        pagination: {
                            paginationModel: { pageSize: 25, page: 0 },
                        },
                    }}
                    disableRowSelectionOnClick
                    checkboxSelection
                />
            )}
            {!isLoading && <Loader />}
        </div>
    );
};

export default SoloChallengeRewardsList;
